import { Component, OnInit } from '@angular/core';
import { RouterOutlet, Router, NavigationError } from '@angular/router';
import { CommonModule } from '@angular/common';
import { LoadingService } from './shared/services/loading.service';
import { PageLoaderComponent } from './shared/stylebook/loader/page-loader.component';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, CommonModule, PageLoaderComponent],
  template: `
    <app-page-loader *ngIf="loadingService.isLoading$ | async"></app-page-loader>

    <router-outlet></router-outlet>
  `,
})
export class AppComponent implements OnInit {
  constructor(
    public readonly loadingService: LoadingService,
    private readonly router: Router
  ) {}

  ngOnInit(): void {
    // RT-3327: dopo un deploy i chunk JS cambiano hash. Se il router non riesce
    // a caricare un lazy chunk (NavigationError con ChunkLoadError), forziamo
    // un reload per ottenere il nuovo index.html con i chunk URL aggiornati.
    this.router.events.pipe(
      filter(e => e instanceof NavigationError)
    ).subscribe((e: NavigationError) => {
      const isChunkError = /Loading chunk [\d]+ failed|ChunkLoadError/.test(e.error?.message ?? '');
      if (isChunkError) {
        // Naviga direttamente all'URL di destinazione con un full reload: evita di
        // ricaricare l'URL corrente (es. /dashboard) e poi passare per AuthGuard
        // con token Amplify ancora in cache, che causerebbe un loop di redirect.
        window.location.href = e.url;
      }
    });
  }
}